export default function (value) {
    let date = value;
    if(typeof date == 'string') {
        date = new Date(date);
    }
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
}